export default "__VITE_ASSET__ae350e1a__"